import { Input, InputNumber, TableColumnsType } from "antd"
import { TOnChangeInTable } from "../../../../../../../components/custom/customDynamicTable"

const getColumns = (onChangeInTable: TOnChangeInTable<IEditProgramTicket>): TableColumnsType<IEditProgramTicket> => [
    {
        title: '티켓명',
        dataIndex: 'name',
        width: '15%',
        render: (value, record, idx) => <>
            {record.isEdit
                ? <Input defaultValue={value} onChange={q => onChangeInTable(idx, 'name', q.target.value)} />
                : <div style={{ paddingInline: '11px', paddingBlock: '5px', marginLeft: '1px' }}>{value}</div>}
        </>
    },
    {
        title: <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <div>티켓설명</div>
            <div style={{ color: 'var(--ant-color-text-description)', fontWeight: '400', fontSize: '12px' }}>※ 프로그램 기간 내 매주 반복됩니다.</div>
        </div>,
        dataIndex: 'description',
        width: '55%',
        render: (value, record, idx) => <>
            {record.isEdit
                ? <Input defaultValue={value} onChange={q => onChangeInTable(idx, 'description', q.target.value)} />
                : <div style={{ paddingInline: '11px', paddingBlock: '5px', marginLeft: '1px' }}>{value}</div>}
        </>
    },
    {
        title: '금액',
        dataIndex: 'payAmount',
        width: '15%',
        render: (value: number, record, idx) => <>
            {record.isEdit
                ? <InputNumber defaultValue={value} onChange={q => onChangeInTable(idx, 'payAmount', Number(q))} formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} />
                : <div style={{ paddingInline: '11px', paddingBlock: '5px', marginLeft: '1px' }}>{value?.toLocaleString()}</div>}
        </>
    },
]

export { getColumns }